import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.6268 3.92146C11.3975 3.1935 12.6025 3.1935 13.3732 3.92146L19.3732 9.58813C19.7733 9.96595 20 10.4919 20 11.0422V20C20 21.1046 19.1046 22 18 22H15C13.8954 22 13 21.1046 13 20V16.3333L11 16.3333V20C11 21.1046 10.1046 22 9 22H6C4.89543 22 4 21.1046 4 20V11.0422C4 10.4919 4.22671 9.96595 4.62675 9.58813L10.6268 3.92146ZM18 11.0422L12 5.37549L6 11.0422L6 20L9 20V16.3333C9 15.2288 9.89543 14.3333 11 14.3333H13C14.1046 14.3333 15 15.2288 15 16.3333V20H18V11.0422Z",
		fill: "currentColor"
	})
});
export default SvgHome;
